var _excluded = ["status"];
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import React from 'react';
import './status-badge.scss';
import { Tooltip } from 'antd';
import titleCase from 'title-case';
import { CheckCircleOutlined, ClockCircleOutlined, CloseCircleFilled, ExclamationCircleOutlined, InfoCircleOutlined, LockFilled, MailFilled, PauseCircleOutlined } from '@ant-design/icons';
import classNames from 'classnames';

// UI only statuses

// Known statuses and UI use status

var DEFAULT_STATUS_TYPE = 'generic';

/**
 * @prop {boolean} [expanded] - The expanded view forces tooltips into hidden mode and
 * displays the status text to the right of the badge
 */

export var StatusBadge = function StatusBadge(_ref) {
  var _props$type;
  var status = _ref.status,
    props = _objectWithoutProperties(_ref, _excluded);
  var statusType = (_props$type = props.type) !== null && _props$type !== void 0 ? _props$type : DEFAULT_STATUS_TYPE;
  var hideTooltip = props.hideTooltip || props.expanded;
  var text = status;
  var icon;
  switch (true) {
    case statusType === 'billing' && status === 'OPEN':
      icon = /*#__PURE__*/React.createElement(InfoCircleOutlined, null);
      break;
    case statusType === 'billing' && status === 'PENDING':
      icon = /*#__PURE__*/React.createElement(ClockCircleOutlined, null);
      break;
    case statusType === 'billing' && status === 'UNCONFIRMED':
    case statusType === 'generic' && status === 'EXPIRED':
      icon = /*#__PURE__*/React.createElement(ExclamationCircleOutlined, null);
      break;
    case statusType === 'user' && status === 'INVITED':
      icon = /*#__PURE__*/React.createElement(MailFilled, null);
      break;
    case statusType === 'user' && status === 'PASSWORD_RESET':
      icon = /*#__PURE__*/React.createElement(LockFilled, null);
      break;
    case statusType === 'user' && status === 'DISABLED':
      icon = /*#__PURE__*/React.createElement(CloseCircleFilled, null);
      break;
    case status === 'DISABLED':
      icon = /*#__PURE__*/React.createElement(PauseCircleOutlined, null);
      break;
    default:
      icon = /*#__PURE__*/React.createElement(CheckCircleOutlined, null);
  }
  var badge = /*#__PURE__*/React.createElement("span", {
    className: "status-icon status-".concat(text)
  }, icon);
  return /*#__PURE__*/React.createElement("span", {
    className: classNames('status-badge', "".concat(statusType, "-status-badge"))
  }, hideTooltip ? !props.expanded ? badge : /*#__PURE__*/React.createElement(React.Fragment, null, badge, /*#__PURE__*/React.createElement("span", {
    className: "status-name"
  }, titleCase(text))) : /*#__PURE__*/React.createElement(Tooltip, {
    title: props.tooltip || text
  }, badge));
};